export function toggleSubnav() {
    const nav = document.querySelector('.subnav');
    const labelOpen = nav?.dataset.labelOpen;
    const labelClose = nav?.dataset.labelClose;

    function toggleItem(submenuLink) {
        const parentItem = submenuLink.closest('.subnav__item');
        if (!parentItem) return;

        const isExpanded = parentItem.classList.contains('expanded');

        parentItem.classList.toggle('expanded', !isExpanded);
        parentItem.classList.toggle('collapsed', isExpanded);

        submenuLink.setAttribute('aria-expanded', !isExpanded);
        submenuLink.setAttribute('aria-label', !isExpanded ? labelClose : labelOpen);
    }

    document.addEventListener('click', function (e) {
        const submenuLink = e.target.closest('.subnav__submenu-link');
        if (!submenuLink) return;

        e.preventDefault();
        e.stopPropagation();
        toggleItem(submenuLink);
    });

    document.addEventListener('keydown', function (e) {
        const submenuLink = e.target.closest('.subnav__submenu-link');
        if (!submenuLink) return;

        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            toggleItem(submenuLink);
        }
    });

    document.querySelectorAll('.subnav__submenu-link').forEach((el, index) => {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-expanded', 'false');
        el.setAttribute('aria-label', labelOpen);

        const parentItem = el.closest('.subnav__item');
        const submenu = parentItem?.querySelector('ul');

        if (submenu) {
            const id = `subnav-submenu-${index}`;
            submenu.id = id;
            el.setAttribute('aria-controls', id);
        }
    });
}
